import { render, staticRenderFns } from "./ColorModalPicker.vue?vue&type=template&id=b3e893ca&scoped=true"
import script from "./ColorModalPicker.vue?vue&type=script&lang=js"
export * from "./ColorModalPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e893ca",
  null
  
)

export default component.exports